export default [
	{ path: "/search/", redirect: { name: "jobs" } },
	{
		path: "/search/jobs",
		name: "jobs",
		component: () =>
			import(
				/* webpackChunkName: "js/pages/search/jobs" */ "@/main/pages/search/Jobs.vue"
			),
	},
	{
		path: "/search/organisations",
		name: "organisations",
		component: () =>
			import(
				/* webpackChunkName: "js/pages/search/organisations" */ "@/main/pages/search/Organisations.vue"
			),
	},
	{
		path: "/search/collections",
		name: "collections",
		component: () =>
			import(
				/* webpackChunkName: "js/pages/search/collections" */ "@/main/pages/search/Collections.vue"
			),
	},
	{
		path: "/search/collection/:slug",
		name: "collection",
		component: () =>
			import(
				/* webpackChunkName: "js/pages/search/collection" */ "@/main/pages/search/Collection.vue"
			),
	},
  {
		path: "/search/volunteering",
		name: "volunteering",
		component: () =>
			import(
				/* webpackChunkName: "js/pages/search/volunteering" */ "@/main/pages/search/Volunteering.vue"
			),
	},
	{
		path: "/category/:slug",
		name: "categories",
		component: () =>
			import(
				/* webpackChunkName: "js/pages/search/categories" */ "@/main/pages/search/Categories.vue"
			),
	},
	{
		path: "/escape100/:year",
		name: "escape100",
		component: () =>
			import(
				/* webpackChunkName: "js/pages/search/escape100" */ "@/main/pages/search/Escape100.vue"
			),
	},
	{
		path: "/events",
		name: "events",
		component: () =>
			import(
				/* webpackChunkName: "js/pages/search/events" */ "@/main/pages/search/Events.vue"
			),
	},
	{
		path: "/resources",
		name: "resources",
		component: () =>
			import(
				/* webpackChunkName: "js/pages/search/resources" */ "@/main/pages/search/Resources.vue"
			),
	},
	{
		path: "/courses",
		name: "programmes-courses",
		component: () =>
			import(
				/* webpackChunkName: "js/pages/search/programmes-courses" */ "@/main/pages/search/ProgrammesCourses.vue"
			),
	},
];
